export default __webpack_public_path__ + "static/media/drone-solarpanel.0ce8c6f4.jpg";